<template>
  <div :class="$style.signInContainer">
    <div :class="$style.header">
      <img
        :class="$style.logo"
        alt=""
        src="/static/img/SignInPageHiloLogo.png"
      />
      <div :class="$style.headerLinks">
        <div :class="$style.newUser">New to Hilo?</div>
        <div :class="$style.signUpLink" @click="goToCreateAccount">Sign Up</div>
<!--        <div :class="$style.supportLink">Support</div>-->
      </div>
    </div>
    <div :class="$style.mainContent">
      <div :class="$style.backgroundBlock" />
      <div :class="$style.contentWrapper">
        <div :class="$style.imageContainer">
          <img
            :class="$style.airplaneImage"
            alt=""
            src="/static/img/SignInPageAirplane.png"
          />
        </div>
        <div :class="$style.formWrapper">
          <div :class="$style.signInForm">
            <b :class="$style.signInTitle">Sign In</b>
            <div :class="$style.inputFieldsWrapper">
              <input
                type="text"
                placeholder="Email"
                :class="$style.emailInputField"
                v-model="email"
                @keyup.enter="signIn"
              />
              <div :class="$style.passwordInputContainer">
                <input
                   :type="showPassword ? 'text' : 'password'"
                  placeholder="Password"
                  :class="$style.passwordInput"
                  v-model="password"
                  @keyup.enter="signIn"
                />
               <img
                 :class="$style.viewPasswordIcon"
                 alt=""
                 src="/static/img/ViewPassword.svg"
                 @click="togglePasswordVisibility"
               />
              </div>
<!--              <div :class="$style.forgotPasswordContainer">-->
<!--                <div :class="$style.text">Forgot Password?</div>-->
<!--                <div :class="$style.helpLinkGroup">-->
<!--                  <div :class="$style.text">Help</div>-->
<!--                  <img-->
<!--                    :class="$style.helpIcon"-->
<!--                    alt=""-->
<!--                    src="/static/img/HelpSquareLinkIcon.svg"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
              <div :class="$style.signInButtonContainer" @click="signIn">
                <b :class="$style.text">Sign In</b>
              </div>
            </div>
            <div :class="$style.textContainer">
              <span>By signing in, I agree to Hilo’s</span>
              <span :class="$style.smallerLinks"> Privacy Policy </span>
              <span>and </span>
              <span :class="$style.smallerLinks">Terms of Service.</span>
            </div>
<!--            <div :class="$style.staySignedInContainer">-->
<!--              <img-->
<!--                :class="$style.checkboxIcon"-->
<!--                alt=""-->
<!--                src="/static/img/Checkbox.svg"-->
<!--              />-->
<!--              <div :class="$style.text">Stay Signed In</div>-->
<!--            </div>-->
<!--            <div :class="$style.signInOptionsDivider">-->
<!--              <img-->
<!--                :class="$style.dividerLine"-->
<!--                alt=""-->
<!--                src="/static/img/HorizontalLine.svg"-->
<!--              />-->
<!--              <div :class="$style.text">Or Sign In With</div>-->
<!--              <img-->
<!--                :class="$style.dividerLine"-->
<!--                alt=""-->
<!--                src="/static/img/HorizontalLine.svg"-->
<!--              />-->
<!--            </div>-->
<!--            <div :class="$style.signInOptions">-->
<!--              <div :class="$style.signInOption">-->
<!--                <img-->
<!--                  :class="$style.signInOptionIcon"-->
<!--                  alt=""-->
<!--                  src="/static/img/SsoSignIn.svg"-->
<!--                />-->
<!--                <div :class="$style.textContainer">SSO</div>-->
<!--              </div>-->
<!--              <div :class="$style.signInOption">-->
<!--                <img-->
<!--                  :class="$style.signInOptionIcon"-->
<!--                  alt=""-->
<!--                  src="/static/img/AppleSignIn.svg"-->
<!--                />-->
<!--                <div :class="$style.text">Apple</div>-->
<!--              </div>-->
<!--              <div :class="$style.signInOption">-->
<!--                <img-->
<!--                  :class="$style.signInOptionIcon"-->
<!--                  alt=""-->
<!--                  src="/static/img/GoogleSignIn.svg"-->
<!--                />-->
<!--                <div :class="$style.text">Google</div>-->
<!--              </div>-->
<!--              <div :class="$style.signInOption">-->
<!--                <img-->
<!--                  :class="$style.signInOptionIcon"-->
<!--                  alt=""-->
<!--                  src="/static/img/FacebookSignIn.svg"-->
<!--                />-->
<!--                <div :class="$style.text">Facebook</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div :class="$style.textContainer">-->
<!--              <span>Hilo is protected by reCAPTCHA and the </span>-->
<!--              <span :class="$style.smallerLinks">Privacy Policy</span>-->
<!--              <span> and </span>-->
<!--              <span :class="$style.smallerLinks">Terms of Service</span>-->
<!--              <span> apply.</span>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div :class="$style.whiteBackground" />
    </div>
  </div>
</template>
<script>
import CommonAPIService from "src/servicehandlers/CommonHandler";
const apiService = new CommonAPIService();
import { useLoginStore } from "@/stores/loginStore";

export default {
  name: "SignIn",
  data() {
    return { email: "", password: "", showPassword: false };
  },
  mounted() {
    this.store = useLoginStore();
  },
  methods: {
    goToCreateAccount() {
      this.$router.push({
        name: "Sign Up",
      });
    },
    goToHome() {
      if (this.store.getLoggedIn) {
        if (this.store.getUser.userType.name === "Hilo Admin") {
          this.$router.push({
            name: "Hilo Admin Dashboard",
          });
        } else if (this.store.getUser.userType.name === "Lender") {
          this.$router.push({
            name: "Lender Dashboard",
          });
        } else {
          this.$router.push({
            name: "Home",
          });
        }
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    signIn() {
      const login = {
        username: this.email,
        password: this.password,
      };
      return apiService
        .login(login, this.$router, this.store, [])
        .then((response) => {
          if (response && response.success) {
            this.goToHome();
          } else {
            alert("There was an error logging in. Please try again.");
          }
        })
        .catch(() => {
          alert("There was an error logging in. Please try again.");
        });
    },
  },
};
</script>
<style module scoped>
.helpLinkGroup {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.logo {
  width: 192.8px;
  position: relative;
  height: 51.7px;
  overflow: hidden;
  flex-shrink: 0;
}
.newUser {
  position: relative;
  letter-spacing: 0.05em;
  line-height: 27.44px;
  font-weight: 500;
  color: #000;
}
.signUpLink {
  position: relative;
  letter-spacing: 0.05em;
  line-height: 27.44px;
  font-weight: 500;
  cursor: pointer;
}
.supportLink {
  position: relative;
  letter-spacing: 0.05em;
  line-height: 27.44px;
  font-weight: 500;
}
.headerLinks {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 49px;
}
.header {
  align-self: stretch;
  background-color: #fff;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  height: 75px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  text-align: center;
  font-size: 17.24px;
  color: #3171e2;
}
.backgroundBlock {
  align-self: stretch;
  flex: 1;
  background-color: #f7f9fa;
  overflow: hidden;
  z-index: 2;
}
.airplaneImage {
  width: 691px;
  position: relative;
  border-radius: 15.68px;
  height: 372px;
  object-fit: cover;
}
.imageContainer {
  align-self: stretch;
  width: 620px;/**originally 720px */
  background-color: #f7f9fa;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 0 100px 150px;
  box-sizing: border-box;
  z-index: 1;
}
.signInTitle {
  position: relative;
  font-size: 45px;
  color: #404040;
}
.text {
  width: 100%;
  border: none;
  outline: none;
  font-size: 16px;
  font-family: inherit;
  background: transparent;
  color: inherit;
}
.emailInputField {
  width: 400px;
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background-color: #fff;
}
.passwordInputContainer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  border-radius: 10px;
  overflow: hidden;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease;
}
.passwordInputContainer:focus-within {
  border-color: #3c78ff;
  background-color: rgba(60, 120, 255, 0.1);
}
.passwordInput {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0 20px;
  outline: none;
  height: 100%;
  box-sizing: border-box;
}
.passwordInput:-webkit-autofill {
  box-shadow: 0 0 0 1000px rgba(60, 120, 255, 0.1) inset;
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #000;
}
.passwordInput:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px rgba(60, 120, 255, 0.3) inset;
}
.viewPasswordIcon {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
}
.helpIcon {
  width: 15.7px;
  position: relative;
  height: 15.1px;
}
.forgotPasswordContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  color: #3c78ff;
}
.signInButtonContainer {
  width: 400px;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
}
.inputFieldsWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  font-size: 18px;
}
.smallerLinks {
  color: #3c78ff;
}
.textContainer {
  align-self: stretch;
  position: relative;
}
.checkboxIcon {
  width: 26px;
  position: relative;
  border-radius: 5px;
  height: 26px;
  overflow: hidden;
  flex-shrink: 0;
}
.staySignedInContainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.dividerLine {
  flex: 1;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}
.signInOptionsDivider {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.signInOption {
  width: 47px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  text-align: center;
}
.signInOptionIcon {
  width: 47px;
  position: relative;
  border-radius: 14.11px;
  height: 43.9px;
  overflow: hidden;
  flex-shrink: 0;
}
.signInOptions {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.signInForm {
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
}
.formWrapper {
  align-self: stretch;
  width: 1008px;
  background-color: #fff;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 0 100px;
  box-sizing: border-box;
  z-index: 0;
}
.contentWrapper {
  align-self: stretch;
  width: 1728px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  z-index: 1;
}
.whiteBackground {
  align-self: stretch;
  flex: 1;
  background-color: #fff;
  overflow: hidden;
  z-index: 0;
}
.mainContent {
  align-self: stretch;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 15px;
  color: rgba(64, 64, 64, 0.75);
  font-family: Helvetica, Arial, sans-serif;
}
.signInContainer {
  width: 100%;
  position: relative;
  background-color: #fff;
  height: 1117px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  font-size: 12px;
  color: #404040;
  font-family: Inter, Arial, sans-serif;
}
</style>
